"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselNav = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Buttons = require("../Buttons");

var _Icon = require("../Icon");

var _Icons = require("../Icons");

var _Layout = require("../Layout");

var _When = _interopRequireDefault(require("../../utils/When"));

var StyledNavWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "CarouselNav__StyledNavWrapper",
  componentId: "sc-1jzaxc3-0"
})((0, _css.default)({
  display: ['none', 'none', 'flex']
}), {
  justifyContent: 'space-between',
  alignItems: 'center'
});
var StyledNavItem = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "CarouselNav__StyledNavItem",
  componentId: "sc-1jzaxc3-1"
})({
  alignItems: 'center',
  alignSelf: 'center',
  zIndex: 20
});
var StyledNavButton = (0, _styledComponents.default)(_Buttons.Button).withConfig({
  displayName: "CarouselNav__StyledNavButton",
  componentId: "sc-1jzaxc3-2"
})((0, _css.default)({
  borderRadius: '50%',
  padding: 4
}), (0, _styledSystem.variant)({
  prop: 'color',
  variants: {
    light: {
      backgroundColor: 'coco'
    },
    dark: {
      backgroundColor: 'ghosted.sonar.light'
    }
  }
}));
var StyledNavButtonIcon = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "CarouselNav__StyledNavButtonIcon",
  componentId: "sc-1jzaxc3-3"
})((0, _styledSystem.variant)({
  prop: 'iconColor',
  variants: {
    light: {
      color: 'sonar'
    },
    dark: {
      color: 'coco'
    }
  }
}));

var CarouselNav = function CarouselNav(_ref) {
  var navHeight = _ref.navHeight,
      navControlsWidth = _ref.navControlsWidth,
      navControlsColor = _ref.navControlsColor,
      isLastItemIntersecting = _ref.isLastItemIntersecting,
      itemsLength = _ref.itemsLength,
      elementsPerPage = _ref.elementsPerPage,
      marginLeft = _ref.marginLeft,
      onNavigateToIndex = _ref.onNavigateToIndex,
      props = (0, _objectWithoutProperties2.default)(_ref, ["navHeight", "navControlsWidth", "navControlsColor", "isLastItemIntersecting", "itemsLength", "elementsPerPage", "marginLeft", "onNavigateToIndex"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      carouselIndex = _useState2[0],
      setCarouselIndex = _useState2[1];

  var goToIndex = function goToIndex(index) {
    setCarouselIndex(index);
    onNavigateToIndex(index);
  };

  var goToPreviousPage = function goToPreviousPage() {
    if (carouselIndex - elementsPerPage < 0) {
      goToIndex(0);
    } else {
      goToIndex(carouselIndex - elementsPerPage);
    }
  };

  var goToNextPage = function goToNextPage() {
    if (carouselIndex + elementsPerPage >= itemsLength) {
      goToIndex(itemsLength - 1);
    } else {
      goToIndex(carouselIndex + elementsPerPage);
    }
  };

  (0, _react.useLayoutEffect)(function () {
    var listener = function listener() {
      goToIndex(0);
    };

    window.addEventListener('resize', listener);
    return function () {
      window.removeEventListener('resize', listener);
    };
  }, []);
  return _react.default.createElement(StyledNavWrapper, (0, _extends2.default)({
    width: Object.values(navControlsWidth).map(function (width) {
      return "".concat(width, "px");
    }),
    minHeight: navHeight,
    maxHeight: navHeight,
    marginRight: Object.values(navControlsWidth).map(function (width) {
      return "-".concat(width + marginLeft, "px");
    }),
    marginLeft: "".concat(marginLeft, "px")
  }, props), _react.default.createElement(StyledNavItem, null, _react.default.createElement(_When.default, {
    condition: carouselIndex > 0
  }, function () {
    return _react.default.createElement(StyledNavButton, {
      color: navControlsColor,
      buttonType: "text",
      action: goToPreviousPage
    }, _react.default.createElement(StyledNavButtonIcon, {
      iconColor: navControlsColor
    }, _react.default.createElement(_Icons.ChevronLeft, null)));
  })), _react.default.createElement(StyledNavItem, null, _react.default.createElement(_When.default, {
    condition: !isLastItemIntersecting
  }, function () {
    return _react.default.createElement(StyledNavButton, {
      color: navControlsColor,
      buttonType: "text",
      action: goToNextPage
    }, _react.default.createElement(StyledNavButtonIcon, {
      iconColor: navControlsColor
    }, _react.default.createElement(_Icons.ChevronRight, null)));
  })));
};

exports.CarouselNav = CarouselNav;
var WindowSizeDefaultProps = {
  XS: 0,
  SM: 0,
  MD: 0,
  LG: 0
};
CarouselNav.defaultProps = {
  navHeight: '100%',
  navControlsWidth: WindowSizeDefaultProps,
  navControlsColor: 'dark',
  isLastItemIntersecting: false,
  itemsLength: 0,
  elementsPerPage: 0,
  marginLeft: 0
};